import React, { useState } from 'react';
import StatisticsChart from '../../charts/StatisticsChart';
import MetricToggle from '../../charts/MetricToggle';
import './ChartPanel.css';

interface StatisticsRowData {
  label: string;
  mer: number;
  mar: number;
  lun: number;
  dom: number;
  sab: number;
  ven: number;
  gio: number;
}

interface ChartPanelProps {
  dailyData: StatisticsRowData[];
  weeklyData: StatisticsRowData[];
  dailyDataPrevYear: StatisticsRowData[];
  weeklyDataPrevYear: StatisticsRowData[];
  activeTab: 'giornaliere' | 'settimanali';
  showComparison: boolean;
  isLoading: boolean;
  error: string | null;
}

const ChartPanel: React.FC<ChartPanelProps> = ({ 
  dailyData, 
  weeklyData, 
  dailyDataPrevYear,
  weeklyDataPrevYear,
  activeTab, 
  showComparison,
  isLoading, 
  error 
}) => {
  // Stato per le metriche selezionate (inizialmente solo Accessi)
  const [selectedMetrics, setSelectedMetrics] = useState<string[]>(['Accessi']);
  
  // Lista delle metriche disponibili
  const availableMetrics = ['Accessi', 'Registrazioni', 'Diete Nuove', 'Conversioni', 'Alimenti'];
  
  const handleMetricToggle = (metric: string) => {
    setSelectedMetrics(prev => {
      if (prev.includes(metric)) {
        // Rimuovi la metrica se già selezionata (ma mantieni almeno una)
        return prev.length > 1 ? prev.filter(m => m !== metric) : prev;
      } else {
        // Aggiungi la metrica se non selezionata
        return [...prev, metric];
      }
    });
  };
  
  if (isLoading) {
    return (
      <div className="chart-panel">
        <div className="panel-header">
          <h3>Grafico Statistiche</h3>
        </div>
        <div className="chart-loading">
          <p>Caricamento grafico...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="chart-panel">
        <div className="panel-header">
          <h3>Grafico Statistiche</h3>
        </div>
        <div className="chart-error">
          <p>Errore nel caricamento del grafico</p>
        </div>
      </div>
    );
  }

  const currentData = activeTab === 'giornaliere' ? dailyData : weeklyData;
  const compareData = activeTab === 'giornaliere' ? dailyDataPrevYear : weeklyDataPrevYear;
  const chartTitle = activeTab === 'giornaliere' 
    ? 'Accessi Giornalieri (Ultimi 7 giorni)' 
    : 'Accessi per Periodo (Ultimi 7 periodi)';

  return (
    <div className="chart-panel">
      <div className="panel-header">
        <h3>Grafico Statistiche</h3>
        <div className="chart-info">
          <span className="chart-tab-indicator">
            {activeTab === 'giornaliere' ? 'Vista Giornaliera' : 'Vista Settimanale'}
          </span>
          {showComparison && (
            <span className="comparison-indicator">
              Con confronto
            </span>
          )}
        </div>
      </div>
      
      <div className="panel-content">
        <StatisticsChart
          data={currentData}
          compareData={compareData}
          showComparison={showComparison}
          title={chartTitle}
          metricsToShow={selectedMetrics}
          isWeekly={activeTab === 'settimanali'}
        />
        
        <MetricToggle
          availableMetrics={availableMetrics}
          selectedMetrics={selectedMetrics}
          onMetricToggle={handleMetricToggle}
        />
      </div>
    </div>
  );
};

export default ChartPanel;